<template>
  <div>
    <!-- <mheader></mheader> -->
    <div
      v-show="tableData.length > 0"
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2">
          <img
            src="../../static/images/kucun_1.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            汇款记录
          </span>
          <span class="ml-5">
            <span>
              显示<span class="record">{{ PageNo }}</span
              >-<span class="record">{{ Pcount }}</span
              >页,
            </span>
            <span>
              总共<span class="record">{{ Record }}</span
              >条数据
            </span>
          </span>
          <el-button
            type="success"
            style="margin-left: 20px"
            size="mini"
            @click="ExportAll"
            >导出全部记录</el-button
          >
          <span
            class="float-right span_close mr-1"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>
        <div>
          <table class="table table-striped table-hover sett" ref="print">
            <thead>
              <tr style="white-space: nowrap" @click="changeWidth($event)">
                <th class="text-center">结算日期</th>
                <th class="text-center">结算单位</th>
                <th class="text-center">结算金额</th>
                <th class="text-center">结算方式</th>
                <th class="text-center">开户行</th>
                <th class="text-center">付款方式</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in tableData"
                :key="index"
                style="white-space: nowrap"
              >
                <td class="text-center">{{ item.settDate | formatUTC }}</td>
                <td class="text-center">{{ item.company }}</td>
                <td class="text-center">{{ item.money }}</td>
                <td class="text-center">{{ item.clearingFrm }}</td>
                <td class="text-center">{{ item.openBank }}</td>
                <td class="text-center">{{ item.payWay }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 分页 -->
        <!-- <div class="row m-0">
          <nav
            aria-label="Page navigation"
            style="text-align: center"
            class="mb-1"
          >
            <ul class="pagination">
              <li
                class="page-item ml-5"
                :class="PageNo <= 1 ? 'disabled' : ''"
                @click="prePage()"
              >
                <a aria-label="Previous" class="page-link">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>

              <li
                :class="index == PageNo ? 'active' : ''"
                class="page-item"
                v-for="index of Pcount"
                :key="index"
                @click="curPage(index)"
              >
                <a class="page-link">{{ index }}</a>
              </li>

              <li
                class="page-item"
                :class="PageNo >= Pcount ? 'disabled' : ''"
                @click="nextPage()"
              >
                <a aria-label="Next" class="page-link">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div> -->
        <el-pagination
          @current-change="CurrentChange"
          :current-page="pageIndex"
          :page-size="pageSize"
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
          style="text-align: center; margin-top: 15px; margin-bottom: 15px"
        >
        </el-pagination>
        <p class="text-center">
          <img
            src="../../static/images/tuding.png"
            style="width: 1.5rem; height: 1.5rem"
            alt=""
          />
        </p>
        <!-- <div class="row p-0 m-0">        
          <p>
            <span>
              查询数量总计：<span class="money">¥{{totalNum}}</span>
            </span>
            <span>
              (真实)销售金额总计: <span class="money">¥{{totalMoney}}</span>
            </span>
            <span>
              (真实)费用合计: <span class="money">¥{{feeMoney}}</span>
            </span>
            <span>
                显示<span class="record">{{PageNo}}</span>-<span class="record">{{Pcount}}</span>条,
            </span>
            <span>
                  总共<span class="record">{{Record}}</span>条数据
            </span> 
          </p>                      
      </div> -->
      </div>
    </div>

    <div
      v-show="Pcount === 0"
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2">
          <img
            src="../../static/images/kucun_1.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            结算查询
          </span>
          <span class="ml-5">
            <span>
              显示<span class="record">{{ PageNo }}</span
              >-<span class="record">{{ Pcount }}</span
              >页,
            </span>
            <span>
              总共<span class="record">{{ Record }}</span
              >条数据
            </span>
          </span>
          <span
            class="float-right span_close"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>
        <img
          src="../../static/images/wushuju.jpg"
          style="width: 300px; height: 300px; display: block; margin: 0 auto"
          alt=""
        />
        <p class="text-center">
          <img
            src="../../static/images/tuding.png"
            style="width: 1.5rem; height: 1.5rem"
            alt=""
          />
        </p>
        <!-- <div class="row p-0 m-0">        
        <p>
          <span>
            查询数量总计：<span class="money">¥{{totalNum}}</span>
          </span>
          <span>
            (真实)销售金额总计: <span class="money">¥{{totalMoney}}</span>
          </span>
          <span>
            (真实)费用合计: <span class="money">¥{{feeMoney}}</span>
          </span>
          <span>
              显示<span class="record">{{PageNo}}</span>-<span class="record">{{Pcount}}</span>条,
          </span>
          <span>
            总共<span class="record">{{Record}}</span>条数据
          </span>                 
        </p>                            
      </div> -->
      </div>
    </div>
    <!-- 表单内容 -->
    <div>
      <transition name="fade">
        <loading v-if="isLoading"></loading>
      </transition>
    </div>
    <!-- Footer -->
    <!-- <mfooter></mfooter> -->
  </div>
</template>
<script>
// import mheader from '../components/Header.vue'
// import mfooter from '../components/Footer.vue'
import Loading from "../components/Loading.vue";

export default {
  name: "SaleQuery",
  data() {
    return {
      Height: 0,
      searchData: [], //搜索返回的清单
      isLoading: false,
      tableData: [],
      Record: "", //总记录数
      Pcount: "", //总页数
      PageNo: 1, //当前页码
      totalNum: "",
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      totalMoney: "",
      feeMoney: "",
      excelData: [],
    };
  },
  components: {
    // mheader,
    // mfooter,
    Loading,
  },
  computed: {},
  filters: {
    getTrue: function (result) {
      if (result) {
        return "是";
      }
      if (!result) {
        return "否";
      }
    },
    formatUTC: function (utc_datetime) {
      return utc_datetime.replace(/T/gi, "  ").substring(0, 20);
    },
  },
  methods: {
    //改变宽度
    changeWidth: function (e) {},
    ExportAll() {
      this.$confirm("此操作将的excel文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("Dls/getFun", {
              action: "ClerkSettlement",
              obj: JSON.stringify({
                PageIndex: 1,
                PageSize: 5000,
              }),
            })
            .then((res) => {
              if (res.data.isok) {
                this.excelData = res.data.data.rows;
                this.export2Excel();
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 导出Excel
    export2Excel() {
      var that = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("../Excel/Export2Excel.js"); //这里必须使用绝对路径，根据自己的命名和路径
        const tHeader = [
          "结算日期",
          "结算单位",
          "结算金额",
          "结算方式",
          "开户行",
          "付款方式",
        ]; // 导出的表头名
        const filterVal = [
          "settDate",
          "company",
          "money",
          "clearingFrm",
          "openBank",
          "payWay",
        ]; // 导出的表头字段名
        const list = that.excelData;
        // that.excelData为传入的数据
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, `汇款记录`); // 导出的表格名称，根据需要自己命名
        // tHeader为导出Excel表头名称，`xxxxxx`即为导出Excel名称
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    SizeChange(val) {
      this.pageSize = val;
      this.getClerkSettlementQuery();
    },
    CurrentChange(val) {
      this.pageIndex = val;
      this.getClerkSettlementQuery(val);
    },
    getClerkSettlementQuery: async function (PageIndex) {
      // this.isLoading=true;
      this.PageNo = PageIndex || this.PageNo;
      const { data: res } = await this.$http.post("Dls/getFun", {
        action: "ClerkSettlement",
        obj: JSON.stringify({
          PageIndex,
          PageSize: 20,
        }),
      });
      if (res.isok) {
        const obj = res.data;
        this.tableData = obj.rows;
        this.Pcount = obj.pcount;
        this.Record = obj.record;
        this.totalNum = obj.totalNum;
        this.totalMoney = obj.totalMoney;
        this.feeMoney = obj.feeMoney;
        this.total = obj.record;
      }
    },

    // 当前页
    curPage: function (index) {
      this.getClerkSettlementQuery(index);
    },
    //上一页
    prePage: function () {
      if (this.PageNo > 1) {
        this.PageNo--;
        this.getClerkSettlementQuery(this.PageNo);
      }
    },
    //下一页
    nextPage: function () {
      if (this.PageNo < this.Pcount) {
        this.PageNo++;
        this.getClerkSettlementQuery(this.PageNo);
      }
    },
    //搜索功能
    // 打印
    start_print() {
      this.$print(this.$refs.print); //$refs的值要和html里的ref一致
    },
  },
  mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 100;
    };
  },
  created() {
    this.getClerkSettlementQuery();
  },
};
</script>
<style scoped>
.table-hover > tbody > tr:hover {
  background-color: #dee2e6 !important;
}
.money {
  color: red;
  font-weight: 500;
}
.record {
  color: green;
  font-weight: 500;
}
.sett {
  width: 1300px;
  table-layout: fixed;
}
.sett-td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -moz-text-overflow: ellipsis;
}
.autocut {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -khtml-text-overflow: ellipsis;
  -moz-text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
}
.autocut:hover {
  overflow: visible;
  width: 200px;
  white-space: nowrap;
  word-wrap: break-word;
  text-align: center;
}
.span_close:hover {
  color: #3190e8;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/pages/Statement.vue